import { Component } from "@builder.io/sdk";

export const benefitsCiIonConfig: Component = {
  name: "Benefits CI-ION",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "benefits-ci-ion",
      friendlyName: "Section ID",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "title",
      type: "string",
      defaultValue: "Benefits",
      friendlyName: "Section Title",
      helperText:
        "The main heading that appears at the top of the benefits section",
      required: true,
    },
    {
      name: "benefits",
      type: "list",
      friendlyName: "Benefits List",
      defaultValue: [
        {
          title: "Flexible Learning",
          text: "Learn on your time, on any internet capable device, wherever you may be.",
          iconName: "flexible-learning",
        },
        {
          title: "Live Workshops",
          text: "Professionals and healthcare providers are brought together to speak about new trends in the healthcare community and industry.",
          iconName: "live-workshops",
        },
        {
          title: "Quality Certification",
          text: "We work with the highest state and industry standards to ensure quality certification and CEUs (when applicable).",
          iconName: "quality-certification",
        },
        {
          title: "Better Pay & Career",
          text: "With better education and certification, you can earn more money than an uneducated or uncertified assistant.",
          iconName: "better-pay-and-career",
        },
      ],
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Benefit Title",
          helperText:
            "Short, descriptive title for this benefit (e.g., 'Flexible Learning')",
          required: true,
        },
        {
          name: "text",
          type: "longText",
          friendlyName: "Benefit Description",
          helperText:
            "Detailed description explaining how this benefit helps learners",
          required: true,
        },
        {
          name: "iconName",
          type: "string",
          friendlyName: "Icon Selection",
          helperText:
            "Choose the visual icon that best represents this benefit: flexible-learning (Clock/Schedule), live-workshops (People/Presentation), quality-certification (Certificate/Award), better-pay-and-career (Money/Growth)",
          enum: [
            "flexible-learning",
            "live-workshops",
            "quality-certification",
            "better-pay-and-career",
          ],
          required: true,
        },
      ],
      helperText:
        "Add or remove benefits to showcase the advantages of CI-ION training. Each benefit includes a title, description, and icon.",
      min: 1,
      max: 6,
    },
    {
      name: "layout",
      type: "string",
      friendlyName: "Layout Style",
      defaultValue: "grid",
      enum: ["grid", "list"],
      helperText:
        "Choose how the benefits are displayed: grid (Cards Layout) or list (Vertical Layout)",
      advanced: true,
    },
    {
      name: "backgroundColor",
      type: "string",
      friendlyName: "Background Color",
      defaultValue: "white",
      enum: ["white", "primary-100", "secondary-100"],
      helperText:
        "Background color for the section: white, primary-100 (Light Primary), or secondary-100 (Light Secondary)",
      advanced: true,
    },
  ],
};
